var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLandingInnerArrow3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "R\\xE9teg_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 157.5 243",
    style: {
      enableBackground: "new 0 0 157.5 243"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#1FBA9C;stroke-width:3;stroke-linecap:round;}\n\t.st1{fill:none;stroke:#1FBA9C;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16164",
    transform: "translate(-428.895 -1334)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10426",
    className: "st0",
    d: "M430.4,1335.5v240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10418",
    className: "st1",
    d: "M430.4,1416.6c0,0,2.3,40,40.7,57.4s113.2,12,113.2,12"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16008",
    transform: "translate(-880.648 1938.933) rotate(-45)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_420",
    className: "st0",
    x1: 1334.4,
    y1: 716.4,
    x2: 1356.3,
    y2: 716.4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_421",
    className: "st0",
    x1: 1356.3,
    y1: 694.5,
    x2: 1356.3,
    y2: 716.4
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingInnerArrow3);
export default __webpack_public_path__ + "static/media/landingInnerArrow3.7570f4d46ffa878d18695852230cbc58.svg";
export { ForwardRef as ReactComponent };